enum ErrorCodesEnum {
    FORBIDDEN_EMAIL_DOMAIN = 'FORBIDDEN_EMAIL_DOMAIN',
}
export { ErrorCodesEnum };
